module.exports = __webpack_public_path__ + "static/media/atu.0705914a.jpg";